export default "__VITE_ASSET__34njjdi1__"